import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { combineLatest, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { scoreQuiz } from 'src/app/quiz/config/quiz';
import { QuestionSubmission } from 'src/app/quiz/models/question-submission.model';
import { QuizQuestion, QuizScoreModel } from 'src/app/quiz/models/quiz-question.model';
import { QuizSettingsModel } from 'src/app/quiz/models/quiz-settings.model';
import { QuizState } from 'src/app/quiz/state/quiz.state';
import { ViewService } from 'src/app/view/view.service';
import { QuizService } from '../view-quiz.service';

@Component({
  selector: 'app-view-quiz-review',
  templateUrl: './view-quiz-review.component.html',
  styleUrls: ['./view-quiz-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizReviewComponent implements OnInit, OnDestroy {

  @Select(QuizState.getAllQuestions)
  questions$: Observable<QuizQuestion[]>;

  @Select(QuizState.getAllSubmissions)
  submissions$: Observable<QuestionSubmission[]>;

  @Select(QuizState.getQuizSettings)
  quizSettings$: Observable<QuizSettingsModel>;

  @Select(QuizState.getQuizModeLocked)
  quizLocked$: Observable<boolean>;

  questions: QuizQuestion[] = [];
  quizScore: QuizScoreModel;

  showSummaryEnabled = false;
  showExplanationEnabled = false;
  showExplanation = false;  

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private changeRef: ChangeDetectorRef,
    private quizService: QuizService) { }

  ngOnInit() {
    this.initReviewListeners();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initReviewListeners() {
    // calculate results
    combineLatest([
      this.questions$,
      this.submissions$
    ])
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(([questions, submissions]) => {
        this.questions = questions;
        this.quizScore = scoreQuiz(questions, submissions);
        this.changeRef.markForCheck();
      });

    // set summary visiblity
    this.quizSettings$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(({ showSummary, showExplanation }) => {
        this.showSummaryEnabled = showSummary !== false;
        this.showExplanationEnabled = showExplanation !== false;
        this.changeRef.markForCheck();
      });
  }

  handleToggleSummaryClick() {
    this.showExplanation = !this.showExplanation;
    this.changeRef.markForCheck();
  }

  handleRestartClick() {
    this.quizService.resetQuiz();
    setTimeout(() => {
      this.quizService.startQuiz();
    });
  }

  handleExitClick() {
    this.quizService.exitQuiz();
  }
}
